import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import _ from "lodash";
import vuetify from "./plugins/vuetify";
import i18n from "./plugins/i18n";
import VueScrollactive from "vue-scrollactive";
import Axios from "./common/axios";
require("./scss/app.scss");
import { Plugin } from "vue-fragment";
Vue.use(Plugin);
// ! NB See ei tööta _shared kaustas millegipärast - annab konsoolis errorit, et vuetify is undefined. !!! vist fixitud
import VuetifyDialog from "@/_shared/plugins/dialog/index";

Axios.init();
// Axios.getAxios().interceptors.response.use(
//     response => response,
//     error => {
//         VuetifyDialog;
//         // console.log("JSON", error.toJSON());
//         // if (parseInt(error.response.status) === 419)
//             // handleCsrfExpireError(error.response.data);

//         throw error;
//     }
// );

// function handleCsrfExpireError(data) {
//     const url = window.location.href;
//     data.notify = '1000'
//     data.href = url;
//     data.message = `Palun värskenda seda lehte.`;
//     data.title = "Sessioon on aegunud";
// }

Vue.use(VueScrollactive);
Vue.config.productionTip = false;

const sharedBetweenApps = require.context("@/_shared/components/auto", true, /\.vue$/i);
const autoComponents = require.context("@/landing/components/auto", true, /\.vue$/i);
for (const components of [sharedBetweenApps, autoComponents]) {
  components.keys().map(key =>
    Vue.component(
      key
        .split("/")
        .pop()
        .split(".")[0],
      components(key).default
    )
  );
}
Vue.component("main-title", require("@/landing/components/MainTitle/MainTitle").default);
Vue.component("MainTitle", require("@/landing/components/MainTitle/MainTitle").default);
Vue.component("secondary-title", require("@/landing/components/MainTitle/SecondaryTitle").default);
Vue.component("SecondaryTitle", require("@/landing/components/MainTitle/SecondaryTitle").default);

Object.defineProperty(Vue.prototype, "_", { value: _ });
import globlProps from "@/landing/static/props";
Vue.prototype.$pr = globlProps;
// Vue.prototype.ASSETS_URL = process.env.BASE_URL;
// Vue.prototype.$asset = function(asset) {
//     return process.env.ASSETS_URL + asset;
// };

const assetsUrl = process.env.NODE_ENV === "production" ? "/assets/landing/" : "";

console.log("process.env.NODE_ENV", process.env.NODE_ENV);
Vue.prototype.ASSETS_URL = assetsUrl;
Vue.prototype.$asset = function (asset) {
  return assetsUrl + asset;
};

Vue.use(VuetifyDialog, {
  context: { vuetify },
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
  data: () => ({
    drawer: true,
    snackbarMessage: "snack snack",
  }),
}).$mount("#app");
